import { render, staticRenderFns } from "./SnackbarNotification.vue?vue&type=template&id=7e2a61df&"
import script from "./SnackbarNotification.vue?vue&type=script&lang=js&"
export * from "./SnackbarNotification.vue?vue&type=script&lang=js&"
import style0 from "./SnackbarNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VSnackbar})
